<template>
    <a-modal width="65%" title="查看" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @cancel="onClose" :footer="null" wrap-class-name="single-spa-vue">

        <a-descriptions :column="1">
            <a-descriptions-item label="项目图片">
                <img-upload v-model:value="form.picture" :showList="true" disabled />
            </a-descriptions-item>
            <a-descriptions-item label="项目名称">{{form.projectName}}</a-descriptions-item>
            <a-descriptions-item label="项目领域">
                <dict-render :dict-obj="dictObjs['technical_field']" :text="form.projectField"></dict-render>
            </a-descriptions-item>
            <a-descriptions-item label="项目阶段">
                <dict-render :dict-obj="dictObjs['projectStage']" :text="form.projectStage"></dict-render>
            </a-descriptions-item>
            <a-descriptions-item label="项目地区">{{form.prov}}{{form.city}}{{form.dist}}</a-descriptions-item>
            <a-descriptions-item label="项目详细地址">{{form.projectArea}}</a-descriptions-item>
            <a-descriptions-item label="项目联系人">{{form.contacts}}</a-descriptions-item>
            <a-descriptions-item label="联系人电话">{{form.contactNumber}}</a-descriptions-item>
            <a-descriptions-item label="融资金额(万元)">{{form.financingAmount}}</a-descriptions-item>
            <a-descriptions-item label="企业估值(万元)">{{form.enterpriseValuation}}</a-descriptions-item>
            <a-descriptions-item label="出让股份(%)">{{form.transferShares}}</a-descriptions-item>
            <a-descriptions-item label="项目概述">{{form.projectOverview}}</a-descriptions-item>
            <a-descriptions-item label="商业计划书">
                <file-upload v-model:value="form.businessPlan" disabled/>
            </a-descriptions-item>
            <a-descriptions-item label="备注">{{form.remark}}</a-descriptions-item>

        </a-descriptions>
    </a-modal>
</template>

<script>
import { 
        dictMixin,formMixin } from "@/mixins";
import DictRender from "@/components/other/DictRender";

export default {
    name: "Detail",
    mixins: [
        dictMixin,formMixin],
        components:{DictRender},
    data() {
        return {
            dictNames: 'projectStage,technical_field',
            form: {
                id: null,
                picture: null,
                projectName: null,
                projectField: null,
                projectStage: null,
                prov: null,
                city: null,
                dist: null,
                projectArea: null,
                contacts: null,
                contactNumber: null,
                financingAmount: null,
                enterpriseValuation: null,
                transferShares: null,
                projectOverview: null,
                businessPlan: null,
                remark: null,
            },
        }
    },
    methods:{
        onClose(){
            this.visible = false
            this.$emit("onCloseModel")
        }
    }
}
</script>

<style scoped lang="less">

</style>
